module.exports = __webpack_public_path__ + "static/media/asc-pin.2c10aea3.svg";